function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M28.417 21.714c1.132 1.313 1.94 2.253 1.423 3.285C29.354 26 27.898 26 27.284 26H4.767c-.971 0-2.136-.094-2.588-1.001-.551-1.032.259-2.065 1.229-3.347 1.132-1.471 2.879-3.317 2.879-5.289V9.981C6.287 4.474 10.493 0 15.961 0c5.435 0 9.673 4.474 9.673 9.981v6.382c0 2.003 1.618 3.974 2.783 5.351zM16 32a4 4 0 0 1-4-4h8a4 4 0 0 1-4 4z"
});

var SvgBellFilled = function SvgBellFilled(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBellFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell-filled.6990523e.svg";
export { ForwardRef as ReactComponent };